export type ApplicationContextSection =
  | 'general'
  | 'technology'
  | 'product'
  | 'ui'
  | 'tenancy'
  | 'auth'
  | 'roles_permissions'
  | 'navigation'
  | 'feature_gating'
  | 'environments'
  | 'data_lifecycle'
  | 'async_realtime'
  | 'localization'
  | 'feedback_errors'
  | 'idiosyncrasies';

export type ApplicationContextSource = 'bootstrap' | 'workflow' | 'manual' | 'cli' | 'groom' | 'assistant';

export type ApplicationContextItem = {
  id: string;
  orgId: string;
  propertyId: string;
  section: ApplicationContextSection;
  itemKey: string;
  itemLabel: string;
  content: string;
  version: number;
  source: ApplicationContextSource;
  sourceId: string | null;
  createdBy: string | null;
  createdAt: string;
};

export type ApplicationContextBootstrap = {
  id: string;
  orgId: string;
  propertyId: string;
  jobId: string | null;
  status: 'pending' | 'running' | 'completed' | 'failed';
  itemsFound: number;
  startedAt: string | null;
  completedAt: string | null;
  createdAt: string;
};

export type ApplicationContextGrouped = Partial<
  Record<ApplicationContextSection, ApplicationContextItem[]>
>;

export const SECTION_LABELS: Record<ApplicationContextSection, string> = {
  general: 'Overview',
  technology: 'Tech Stack',
  product: 'Domain Model',
  navigation: 'Navigation Model',
  tenancy: 'Tenancy & Workspaces',
  auth: 'Authentication & Sessions',
  roles_permissions: 'Roles & Permissions',
  feature_gating: 'Feature Gating',
  environments: 'Environments',
  data_lifecycle: 'Entity Lifecycle',
  async_realtime: 'Async & Realtime',
  localization: 'Localization',
  ui: 'UI Patterns',
  feedback_errors: 'Feedback & Error Signals',
  idiosyncrasies: 'Idiosyncrasies',
};

export const SECTION_ORDER: ApplicationContextSection[] = [
  'general',
  'technology',
  'product',
  'navigation',
  'tenancy',
  'auth',
  'roles_permissions',
  'feature_gating',
  'environments',
  'data_lifecycle',
  'async_realtime',
  'localization',
  'ui',
  'feedback_errors',
  'idiosyncrasies',
];
